import {minmax, sectionToFixedMap} from '../shared.js';
import {buildNarrativeTextTimeline} from '../animations.js';
import {queueTicker} from '../ticker.js';

const article = document.querySelector('#chapter19');
const section = article.querySelector('#chapter19-narrative');
const fixed = sectionToFixedMap.get(section);
const text = fixed.querySelector('.narrative-text');
const timeline = new TimelineLite({paused: true});

const start2018 = 250;

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter19:init');

  buildNarrativeTextTimeline(timeline, text, 85);

  timeline.call(() => queueTicker(2017), null, null, start2018 - 1);
  timeline.call(() => queueTicker(2018), null, null, start2018);

  section.addEventListener('scrub', ({detail: {vh}}) => {
    timeline.seek(minmax(0, vh, timeline.duration()), false);
    if (vh >= start2018) {
      queueTicker(2018);
    } else {
      queueTicker(2017);
    }
  });
}

/**
 * Handle year changes within section
 * @param {Number} vh viewport height units
 */
function yearChange({detail: {vh}}) {
  if (vh <= start2018) {
    queueTicker(2017);
  } else {
    queueTicker(2018);
  }
}
